module.exports = __webpack_public_path__ + "img/coin.02134447.svg";